import React from "react";
import PaymentMethodCard from "./PaymentMethodCard";
import CollapsedSchemeBrands from "./CollapsedSchemeBrands";
import styles from "./payment.module.css";

export default function PaymentAccordion({
  rows,
  selectedRowKey,
  onSelectRow,
  isMethodLocked,
  lockSecondsRemaining,
  renderExpanded,
}) {
  if (!rows?.length) {
    return (
      <p className={styles.emptyPm}>No additional payment methods are available for this session.</p>
    );
  }

  return (
    <div className={styles.accordion} role="list">
      {rows.map((row) => {
        const locked = isMethodLocked(row.internalKey);
        const selected = selectedRowKey === row.rowKey;
        return (
          <PaymentMethodCard
            key={row.rowKey}
            rowKey={row.rowKey}
            selected={selected}
            disabled={locked && !selected}
            locked={locked}
            lockSecondsRemaining={lockSecondsRemaining(row.internalKey)}
            icon={row.icon}
            label={row.label}
            description={row.description}
            hideDescriptionWhenCollapsed={row.adyenType === "scheme"}
            collapsedTrailing={
              row.adyenType === "scheme" ? <CollapsedSchemeBrands /> : null
            }
            onSelect={() => onSelectRow(row)}
          >
            {selected ? renderExpanded(row) : null}
          </PaymentMethodCard>
        );
      })}
    </div>
  );
}
